import { ProgressCircle } from '@chakra-ui/react'

export default ({ value, withValue, size }) => {
  return (
    <ProgressCircle.Root size={size} value={value} colorPalette='primary'>
      <ProgressCircle.Circle>
        <ProgressCircle.Track />
        <ProgressCircle.Range />
      </ProgressCircle.Circle>
      {withValue && <ProgressCircle.ValueText />}
    </ProgressCircle.Root>
  )
}
